export default __webpack_public_path__ + "static/media/arrows-blue.96d504ba.svg";